const CodeShorDic = {
    CODE_00: { code: "00", name: "a" },
    code01: { code: "01", name: "b" },
    code02: { code: "02", name: "c" },
    code03: { code: "03", name: "d" },
    code04: { code: "04", name: "e" },
    code05: { code: "05", name: "f" },
    code06: { code: "06", name: "g" },
    code07: { code: "07", name: "h" },
    code08: { code: "08", name: "i" },
    code09: { code: "09", name: "j" },
    code10: { code: "10", name: "，" },
    code11: { code: "11", name: "k" },
    code12: { code: "12", name: "l" },
    code13: { code: "13", name: "m" },
    code14: { code: "14", name: "n" },
    code15: { code: "15", name: "o" },
    code16: { code: "16", name: "p" },
    code17: { code: "17", name: "q" },
    code18: { code: "18", name: "r" },
    code19: { code: "19", name: "s" },
    code20: { code: "20", name: "t" },
    code21: { code: "21", name: "u" },
    code22: { code: "22", name: "v" },
    code23: { code: "23", name: "w" },
    code24: { code: "24", name: "x" },
    code25: { code: "25", name: "y" },
    code26: { code: "26", name: "z" },
    code27: { code: "27", name: "A" },
    code28: { code: "28", name: "B" },
    code29: { code: "29", name: "C" },
    code30: { code: "30", name: "D" },
    code31: { code: "31", name: "E" },
    code32: { code: "32", name: "F" },
    code33: { code: "33", name: "G" },
    code34: { code: "34", name: "H" },
    code35: { code: "35", name: "I" },
    code36: { code: "36", name: "J" },
    code37: { code: "37", name: "K" },
    code38: { code: "38", name: "L" },
    code39: { code: "39", name: "M" },
    code40: { code: "40", name: "N" },
    code41: { code: "41", name: "O" },
    code42: { code: "42", name: "P" },
    code43: { code: "43", name: "Q" },
    code44: { code: "44", name: "R" },
    code45: { code: "45", name: "S" },
    code46: { code: "46", name: "T" },
    code47: { code: "47", name: "U" },
    code48: { code: "48", name: "V" },
    code49: { code: "49", name: "W" },
    code50: { code: "50", name: "X" },
    code51: { code: "51", name: "Y" },
    code52: { code: "52", name: "Z" },
    code53: { code: "53", name: "|" },
    code54: { code: "54", name: ":" },
    code55: { code: "55", name: ";" },
    code56: { code: "56", name: "[" },
    code57: { code: "57", name: "]" },
    code58: { code: "58", name: "*" },
    code59: { code: "59", name: "+" },
    code60: { code: "60", name: "-" },
    code61: { code: "61", name: "{" },
    code62: { code: "62", name: "}" },
    code63: { code: "63", name: "<" },
    code64: { code: "64", name: ">" },
    code65: { code: "65", name: "@" },
    code66: { code: "66", name: "!" },
    code67: { code: "67", name: "#" },
    code68: { code: "68", name: "$" },
    code69: { code: "69", name: "%" },
    code70: { code: "70", name: "^" },
    code71: { code: "71", name: "&" },
    code72: { code: "72", name: "(" },
    code73: { code: "73", name: ")" },
    code74: { code: "74", name: "=" },
    code75: { code: "75", name: "~" },
    code76: { code: "76", name: "`" },
    code77: { code: "77", name: "1" },
    code78: { code: "78", name: "2" },
    code79: { code: "79", name: "3" },
    code80: { code: "80", name: "4" },
    code81: { code: "81", name: "5" },
    code82: { code: "82", name: "6" },
    code83: { code: "83", name: "7" },
    code84: { code: "84", name: "8" },
    code85: { code: "85", name: "9" },
    code86: { code: "86", name: "0" },
    code87: { code: "87", name: "." },
    code88: { code: "88", name: "/" },
    code89: { code: "89", name: "：" },
    code90: { code: "90", name: "【" },
    code91: { code: "91", name: "】" },
    code92: { code: "92", name: "￥" },
    code93: { code: "93", name: "?" },
    code94: { code: "94", name: "！" },
    code95: { code: "95", name: "？" },
    code96: { code: "96", name: "、" },
    code97: { code: "97", name: "；" },
    code98: { code: "98", name: "‘" },
    code99: { code: "99", name: "“" }
  };

  export function getNameByCode(code) {

    for (const key in CodeShorDic) {
      if (CodeShorDic[key].code === code) {
        return CodeShorDic[key].name;
      }
    }
    return null;
  }

export function getCodeByName(name) {
    for (const key in CodeShorDic) {
      if (CodeShorDic[key].name === name) {
        return CodeShorDic[key].code;
      }
    }
    return null;
  }